import { render, staticRenderFns } from "./JsCodesConfig.vue?vue&type=template&id=32c10e7e&scoped=true&"
import script from "./JsCodesConfig.vue?vue&type=script&lang=js&"
export * from "./JsCodesConfig.vue?vue&type=script&lang=js&"
import style0 from "./JsCodesConfig.vue?vue&type=style&index=0&id=32c10e7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c10e7e",
  null
  
)

export default component.exports